<template>
  <v-footer class="px-0 mt-2" color="transparent">
     <div class="container-fluid" style="margin-right:auto; margin-left:auto;">
                <div class="row" >
                     <div class="col-xs-3">
                    </div>
                    <div class="col-xs-6 col-md-12">©2021 {{server}} - <a href="https://www.ausa.com.mx">Grupo Ausa S.A. de C.V. </a>
                    </div>
                    <div class="col-xs-3 ">
                    </div>
                </div>
            </div>
  </v-footer>
</template>

<style src="@/views/shared/footer/Footer.scss" lang="scss"></style>
<script>
import { mapState, mapMutations } from 'vuex';
    export default {
        data:() => ({
            server: ""
        }),
        computed: {
            ...mapState(['domain'])
        },
        methods: {
            obtenerServer(){
                    this.axios.post(`${this.domain.domainNameForApi}Server`).then(response => {
                       
                        this.server = response.data;
                    })
                
            }
        },
        mounted() {
            this.obtenerServer();
        },
    }
</script>   